import request from "../utils/request";

export function getMessageList(userId, institutionId, params) {
  return request.get(
    `/api/message/v1/user/${userId}/${institutionId}/messages`,
    { params }
  );
}

export function sendMessage(userId, institutionId, body) {
  return request.post(
    `api/message/v1/user/${userId}/${institutionId}/message`,
    body
  );
}

export function repealMessage(institutionId, messageId) {
  return request.post(
    `api/message/v1/user/cancel/${institutionId}/${messageId}`,
    body
  );
}
